import React from "react";

interface StatCardProps {
  label: string;
  value: string | number;
}

const StatCard: React.FC<StatCardProps> = ({ label, value }) => (
    <div className="p-[2px] rounded-2xl bg-gradient-to-r from-cyan-900 to-cyan-700 w-full">
    <div className="bg-[#172a3a] rounded-2xl py-1 flex flex-col items-center">
      <div className="text-cyan-300 text-xs mb-1 font-medium">{label}</div>
      <div className="text-2xl font-bold  text-white">{value}</div>
    </div>  
  </div>
);

export default StatCard; 
